import type { Post } from '@tribeplatform/gql-client/types'
import { useUpdateMemberPostNotificationSettings } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'

import { EntityImage } from '../../common/components/EntityImage.js'
import { useLogin } from '../../common/hooks/useLogin.js'
import { convertIdToGlyph } from '../../MediaPicker/utils/utils.js'
import { FollowAction as TFollowAction } from '../../Views/types.js'
import { getTextIconSettings } from '../utils/utils.js'

interface Props {
  post: Post
  action: TFollowAction
}
export const FollowAction = ({ post, action }: Props) => {
  const {
    defaultLabel,
    variant,
    glyphId,
    color,
    activeLabel,
    activeGlyphId,
    activeColor,
  } = action
  const { isLoggedIn, showLogin } = useLogin()
  const { isLoading, mutate: updateMemberPostNotificationSettings } =
    useUpdateMemberPostNotificationSettings()
  const isFollowed =
    post?.authMemberProps?.memberPostNotificationSettingsEnabled
  const { showText, showIcon } = getTextIconSettings(variant)

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = e => {
    if (!isLoggedIn) {
      e.preventDefault()
      showLogin()
      return
    }

    if (isLoading) {
      return
    }

    updateMemberPostNotificationSettings({
      input: {
        enabled: !isFollowed,
      },
      postId: post?.id,
    })
  }

  return (
    <div className="flex-1">
      <Button
        variant="secondaryNeutral"
        className="group select-none"
        pressed={isFollowed}
        size="lg"
        fullWidth
        leadingIcon={
          showIcon &&
          (isFollowed ? (
            <EntityImage
              entity={{
                image: convertIdToGlyph(activeGlyphId || glyphId),
                name: activeLabel || (defaultLabel ?? ''),
              }}
              size="lg"
              displayColor={activeColor || (color ?? '')}
              iconStyle="solid"
            />
          ) : (
            <EntityImage
              entity={{
                image: convertIdToGlyph(glyphId),
                name: defaultLabel || '',
              }}
              size="lg"
              displayColor={color}
            />
          ))
        }
        onClick={handleClick}
      >
        {showText && (
          <span className="truncate">
            {isFollowed ? activeLabel || defaultLabel : defaultLabel}
          </span>
        )}
      </Button>
    </div>
  )
}
